import { useSelector } from 'react-redux';

// material-ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import { dispatch, RootState } from 'store';
import { setDialogOpen, setDialogResult } from 'store/reducers/dialog';

// ===============================|| UI DIALOG - SWEET ALERT ||=============================== //

export default function AlertDialog() {
  const { dialogOpen, dialogTitle, dialogContent, dialogButtons } = useSelector(
    (state: RootState) => state.dialog
  );

  const handleClose = () => {};

  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent sx={{ whiteSpace: 'pre-line', pt: 2, pb: 2 }}>
          <Typography>{dialogContent}</Typography>
        </DialogContent>
        <DialogActions sx={{ pr: 2.5 }}>
          {dialogButtons && dialogButtons[0] && (
            <Button
              color={dialogButtons.length > 1 ? 'error' : 'primary'}
              size="medium"
              variant="outlined"
              onClick={() => {
                dispatch(setDialogResult(false));
                dispatch(setDialogOpen({ dialogOpen: false }));
              }}
            >
              {dialogButtons[0]}
            </Button>
          )}
          {dialogButtons && dialogButtons[1] && (
            <Button
              variant="contained"
              size="medium"
              onClick={() => {
                dispatch(setDialogResult(true));
                dispatch(setDialogOpen({ dialogOpen: false }));
              }}
            >
              {dialogButtons[1]}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
